import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Header, Table } from '../CommonComponents';
import { Container, Paper } from '../StyledComponents';
import { getAllTenantArticles, TenantArticleListItem } from '../../api-admin/tenant-articles';
import { getTenantLinkForArticles } from '../../utils/getTenantLink';

const columns = [{
    name: 'Titel',
    key: 'title',
    canSearch: true
}, {
    name: 'Status',
    key: 'statusLabel',
    type: 'multi-select' as const,
    canFilter: true,
    options: [
        { label: 'Utkast', value: 'Utkast' },
        { label: 'Publicerad', value: 'Publicerad' }
    ],
    exclusive: true
}, {
    name: 'Publicerad',
    key: 'publishedAt',
    type: 'datetime' as const,
    canFilter: true,
    filterType: 'publicationDate' as const,
    filterSectionLabel: 'Publiceringsdatum',
    showWhenFilterIncludes: { columnKey: 'statusLabel', value: 'Publicerad' }
}, {
    name: 'Företag',
    key: 'tenantName',
    canSearch: true,
    getValue: getTenantLinkForArticles
}];

export default function Articles() {
    const navigate = useNavigate();
    const [articles, setArticles] = React.useState<Array<TenantArticleListItem & { statusLabel: string }>>([]);
    const [isFetching, setIsFetching] = React.useState(true);

    React.useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const data = await getAllTenantArticles();
                if (cancelled) return;
                setArticles(data.map((article) => ({
                    ...article,
                    statusLabel: article.status === 'published' ? 'Publicerad' : 'Utkast'
                })));
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(error);
                if (!cancelled) {
                    setArticles([]);
                }
            } finally {
                if (!cancelled) {
                    setIsFetching(false);
                }
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <Container>
            <Header title="Artiklar" />

            <Paper padding={0}>
                <Table
                    name="articles"
                    columns={columns}
                    data={articles}
                    onRowClick={(article: { id: number; tenantId: number }) => {
                        navigate(`/tenants/${article.tenantId}/articles/${article.id}/edit`);
                    }}
                    emptyText={isFetching ? 'Hämtar artiklar...' : 'Det finns inga artiklar.'}
                    showPagination
                    defaultOrderBy="publishedAt"
                    defaultOrderDirection="desc"
                />
            </Paper>
        </Container>
    );
}
